/**
 * Return a value as an array, removing any empty values.
 */
export default function asArray(value) {
    if (Array.isArray(value)) {
        return value.filter(Boolean);
    }
    if (value) {
        return [value];
    }
    return [];
}
